import { Component } from '@angular/core';
import { ApplicationFilesService } from '../../shared/services/application-files.service';

@Component({
  selector: 'ins-home',
  templateUrl: './home.component.html',
})
export class HomeComponent {
  constructor(private appFilesService: ApplicationFilesService) {}

  downloadClaimPacket(): void {
    this.appFilesService.downloadFile('Claim Forms\\Claim Packet.pdf');
  }
}
